import { useState } from "react";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import { provinceData } from "../../../types/indonesiaData";

const GEO_URL = "https://raw.githubusercontent.com/superpikar/indonesia-geojson/master/indonesia-province.json";

const normalizeName = (name: string) => name.trim().toLowerCase();

const IndonesiaMap = () => {
  const [selectedProvince, setSelectedProvince] = useState<string | null>(null);

  const getProvinceColor = (provinceName: string) => {
    const key = normalizeName(provinceName);
    const cities = provinceData[key];

    if (!cities) return "#374151"; // abu default

    const hasDisaster = cities.some((c) => c.disaster);
    const hasPoverty = cities.some((c) => c.poverty !== undefined);

    if (hasPoverty) return "#DC2626"; // 🔴 merah = kemiskinan
    if (hasDisaster) return "#FACC15"; // 🟡 kuning = bencana

    return "#374151";
  };

  const selectedKey = selectedProvince ? normalizeName(selectedProvince) : null;
  const selectedCities = selectedKey ? provinceData[selectedKey] : [];

  return (
    <div className="w-full max-w-6xl mx-auto overflow-visible">
      <ComposableMap
        projection="geoEqualEarth"
        projectionConfig={{
          scale: 1100,
          center: [118, -3],
        }}
        style={{ width: "100%", height: "50%" }}>
        <Geographies geography={GEO_URL}>
          {({ geographies }: { geographies: any[] }) =>
            geographies.map((geo) => {
              const provinceName = geo.properties?.Propinsi ?? geo.properties?.NAME_1 ?? "Unknown";

              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  onClick={() => setSelectedProvince(provinceName)}
                  style={{
                    default: {
                      fill: getProvinceColor(provinceName),
                      outline: "none",
                    },
                    hover: {
                      fill: "#2563EB",
                      cursor: "pointer",
                      outline: "none",
                    },
                    pressed: {
                      fill: "#1E40AF",
                      outline: "none",
                    },
                  }}
                />
              );
            })
          }
        </Geographies>
      </ComposableMap>

      {/* MODAL */}
      {selectedProvince && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl p-6 w-[360px] max-h-[80vh] overflow-y-auto relative">
            <button onClick={() => setSelectedProvince(null)} className="absolute top-3 right-3 text-gray-400 hover:text-black">
              ✕
            </button>

            <h3 className="text-xl font-bold mb-4">{selectedProvince}</h3>

            {selectedCities?.length ? (
              <ul className="space-y-3 max-h-[400px] overflow-y-auto pr-2">
                {selectedCities.map((city, i) => (
                  <li key={i} className="border rounded-lg p-3">
                    <p className="font-semibold">{city.name}</p>

                    {city.poverty !== undefined && (
                      <p className="text-red-600 text-sm">
                        Kemiskinan: <strong>{city.poverty} Jiwa</strong>
                      </p>
                    )}

                    {city.disaster && (
                      <>
                        <p className="text-yellow-600 text-sm">
                          Status Bencana: <strong>{city.disaster.level}</strong>
                        </p>
                        <p className="text-yellow-600 text-sm">
                          Jenis: <strong>{city.disaster.status}</strong>
                        </p>
                      </>
                    )}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-gray-500 text-sm">Tidak ada data tersedia</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default IndonesiaMap;
